import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/peluang-investasi',
    name: 'investment',
    component: () => import('../views/InvestmentView.vue') 
  },
  {
    path: '/tentang-proyek',
    name: 'about-project',
    component: () => import('../views/AboutProjectView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes
})

export default router